// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._154iidpf{top:0}
._1bah1h6o{justify-content:center}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._1ltvidpf{left:0}
._4cvr1h6o{align-items:center}
._4t3i1osq{height:100%}
._kqswstnw{position:absolute}
._syazw5hi{color:var(--_1qgzj18)}
._vr2wstnw span{position:absolute}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-card/dist/esm/card/ui/playButton/playButtonWrapper-compiled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,KAAK;AAChB,WAAW,sBAAsB;AACjC,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,MAAM;AACjB,WAAW,kBAAkB;AAC7B,WAAW,WAAW;AACtB,WAAW,iBAAiB;AAC5B,WAAW,qBAAqB;AAChC,gBAAgB,iBAAiB","sourcesContent":["._154iidpf{top:0}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1ltvidpf{left:0}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._kqswstnw{position:absolute}\n._syazw5hi{color:var(--_1qgzj18)}\n._vr2wstnw span{position:absolute}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
